import { registerAction } from '../../Action'

const SET_WEEK_VIEW_WIDTH = 'SET_WEEK_VIEW_WIDTH'

const reducer = (state = {}, action) => ({
  ...state,
  weekViewWidth: action.payload,
})

const setWeekViewWidth = registerAction(SET_WEEK_VIEW_WIDTH, { reducer })

export default setWeekViewWidth
